module.exports = __webpack_public_path__ + "img/1_C.c4cc6ec2.webp";